function cov_2ivfm6f0vc() {
  var path = "/__w/code/code/js/packages/bricks/src/hooks/useObservabilitySafe.ts";
  var hash = "17551ad290bc6eefdc3d4f88ab95e5ed2a12281c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/hooks/useObservabilitySafe.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 36
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 48
        },
        end: {
          line: 18,
          column: 5
        }
      },
      "2": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 34,
          column: 4
        }
      },
      "3": {
        start: {
          line: 20,
          column: 11
        },
        end: {
          line: 31,
          column: 5
        }
      },
      "4": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 24,
          column: 18
        }
      },
      "5": {
        start: {
          line: 23,
          column: 10
        },
        end: {
          line: 23,
          column: 32
        }
      },
      "6": {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 29,
          column: 18
        }
      },
      "7": {
        start: {
          line: 28,
          column: 10
        },
        end: {
          line: 28,
          column: 37
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 36
          },
          end: {
            line: 10,
            column: 37
          }
        },
        loc: {
          start: {
            line: 13,
            column: 5
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        },
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 31,
            column: 5
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 21,
            column: 22
          },
          end: {
            line: 21,
            column: 23
          }
        },
        loc: {
          start: {
            line: 21,
            column: 44
          },
          end: {
            line: 25,
            column: 7
          }
        },
        line: 21
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 26,
            column: 25
          },
          end: {
            line: 26,
            column: 26
          }
        },
        loc: {
          start: {
            line: 26,
            column: 76
          },
          end: {
            line: 30,
            column: 7
          }
        },
        line: 26
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "17551ad290bc6eefdc3d4f88ab95e5ed2a12281c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ivfm6f0vc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2ivfm6f0vc();
import { useMemo } from 'react';
import { useObservability } from '@opendoor/observability';
cov_2ivfm6f0vc().s[0]++;

/**
 * This wrapper hook is added because not every FE app is onboarded to use observability, and observability
 * expects `globalObservability` to have been initialized when `trackUserEvent` is called. Thus, within the
 * scope of `bricks`, we catch any errors of the real `trackUserEvent` call.
 */
export var useObservabilitySafe = function useObservabilitySafe() {
  cov_2ivfm6f0vc().f[0]++;

  var _ref = (cov_2ivfm6f0vc().s[1]++, useObservability()),
      _trackUserEvent = _ref.trackUserEvent,
      _trackJourneyEvent = _ref.trackJourneyEvent;

  cov_2ivfm6f0vc().s[2]++;
  return useMemo(function () {
    cov_2ivfm6f0vc().f[1]++;
    cov_2ivfm6f0vc().s[3]++;
    return {
      trackUserEvent: function trackUserEvent(event) {
        cov_2ivfm6f0vc().f[2]++;
        cov_2ivfm6f0vc().s[4]++;

        try {
          cov_2ivfm6f0vc().s[5]++;

          _trackUserEvent(event);
        } catch (_unused) {} // eslint-disable-line no-empty

      },
      trackJourneyEvent: function trackJourneyEvent() {
        cov_2ivfm6f0vc().f[3]++;
        cov_2ivfm6f0vc().s[6]++;

        try {
          cov_2ivfm6f0vc().s[7]++;

          _trackJourneyEvent.apply(void 0, arguments);
        } catch (_unused2) {} // eslint-disable-line no-empty

      }
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
};